import DashboardElement from "~/models/dashboards/dashboardElement";

export default class Subheading extends DashboardElement {
  font_size: number;

  constructor() {
    super();
    this.defineProperty("font_size", 1);
  }
}